










































import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user/user.store';
import { ReactionsMap, GetReactionIcon } from '@/core/reactions/Reactions';
import breakpointsStateObservable from '@/core/responsive/breakpointsState.observable';

import Reaction from './Reaction.vue';
import Tabs from '@/core/layout/Tabs/Tabs.vue';
import Tab from '@/core/layout/Tabs/Tab.vue';
import { ReactionType, ReactionViewObject } from '@/types/apiServerContract';

@Component({
    components: { Reaction, Tabs, Tab }
})
export default class Reactions extends Vue {
	@Prop({ required: true, type: Array }) reactions!: ReactionViewObject[];
	@Prop({ required: false, type: Boolean, default: false }) loading!: boolean;
	@Prop({ required: false, type: Boolean, default: false }) isLoggedIn!: boolean;
	@Prop({ required: false, type: [String, Number], default: null }) entityId!: string | number;

	get isPhoneView() {
	    return breakpointsStateObservable.isBreakpointActive('max-md');
	}

	get id() {
	    return 'reaction-' + new Date().valueOf();
	}

	get userId() {
	    return UserModule.user?.id;
	}

	get allReactions() {
	    return ReactionsMap();
	}

	getReactionsByType(type: ReactionType) {
	    return this.reactions.filter(x => x.type === type);
	}

	hasUserReactedTo(type: ReactionType) {
	    return this.reactions.find(x => x.type === type && x.author === this.userId) != null;
	}

	getReactionCount(type: ReactionType): number {
	    return this.reactions.filter(x => x.type === type).length;
	}

	getReactionIcon(type: ReactionType) {
	    return GetReactionIcon(type);
	}

	reacted(data: { type: ReactionType; active: boolean }) {
	    this.$emit('reacted', { type: data.type, active: data.active, entityId: this.entityId });
	}
}
